module.exports = __webpack_public_path__ + "img/sec-223-leading.496367e8.svg";